// Display helpers shared by the portal screens.

export function formatMoney(amount, currency = 'USD') {
  if (amount === null || amount === undefined) return '—';
  const value = Number(amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return currency === 'USD' ? `$${value}` : `${currency} ${value}`;
}

export function formatDate(iso) {
  if (!iso) return '—';
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? iso : date.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}

export function formatPercent(value) {
  return value === null || value === undefined ? '—' : `${Math.round(value)}%`;
}

export function termLabel(term) {
  return term ? `Term ${term.term_number}, ${term.year}` : '';
}

export function classLabel(student) {
  return student.class_display_name || [student.class_name, student.stream].filter(Boolean).join(' ') || 'No class yet';
}
